import { MiddlewareNextFn, RelayRequestAny } from "react-relay-network-modern";
import { toast } from "react-toastify";
import { logout } from "../hooks/use-auth-context/use-auth-context.hook";
import { ERROR_MESSAGES } from "../translations/error-messages";

const LOGOUT_ERRORS = [
	"auth_refresh_token_expired",
	"auth_jwt_malformed",
	"auth_token_not_set_in_headers_exception",
	"supabase jwt token expired",
	// Terminal Supabase failure: no refresh can fix it, so the session has to end.
	"supabase token could not be verified",
	"SUPABASE_TOKEN_NOT_VERIFIABLE",
].map((e) => e.toLowerCase());

export const ErrorHandlingMiddleware = (next: MiddlewareNextFn) => async (req: RelayRequestAny) => {
	const res = await next(req);
	const errors = res.errors?.map((e) => e.message?.toLowerCase()) || [];
	const needsToLogout = LOGOUT_ERRORS.find((le) => errors.includes(le));
	if (needsToLogout) {
		await logout();
	} else {
		errors?.forEach((e) => {
			const message = ERROR_MESSAGES[e] || e;
			toast.error(message.replaceAll("_", " "));
		});
	}

	return res;
};
